import { Add } from '@mui/icons-material';
import { Button, Fab } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface AddItemButtonProps {
  isMobile: boolean;
  onClick: () => void;
}

export function AddItemButton({ isMobile, onClick }: AddItemButtonProps) {
  const { t } = useTranslation();

  if (isMobile) {
    return (
      <Fab
        color="primary"
        aria-label={t('goodsReceiving.addItem')}
        onClick={onClick}
        sx={{
          position: 'fixed',
          bottom: 100,
          right: 16,
        }}
      >
        <Add />
      </Fab>
    );
  }

  return (
    <Button variant="contained" startIcon={<Add />} onClick={onClick} fullWidth>
      {t('goodsReceiving.addItem')}
    </Button>
  );
}
